
import '../post-table';
import '../post-table-item';

new Vue({
    el: '#app'
});

// Vue.component('reference', {
//     props: ['post'],
//     template: `
//     <tr class="c-references-item">
//         <td class="c-references-item-img-wrapper">
//             <div class="o-img-1/1">
//                 <img v-bind:src="post.thumbnail" class="c-references-item-img" alt="">
//             </div>
//         </td>
//         <td class="c-references-item-content">
//             <div class="c-references-item-meta"><span>{{ new Date(post.post_date).getFullYear() }}</span><span v-for="cat in post.categories">{{ cat.name }}</span></div>
//             <h6 class="c-references-item-title" v-html="post.post_title"></h6>
//             <p class="c-references-item-excerpt">{{ post.post_excerpt }}</p>
//         </td>
//         <td class="c-references-item-link"><a v-bind:href="post.permalink" class="o-link">Zur Publikation <svg><use xlink:href="#arrow-right"></use></svg></a></td>
//     </tr>`
// });

// var app = new Vue({
//     el: '#publications',
//     data: {
//         posts: [],
//         filter: [],
//         year: ""
//     },
//     computed: {
//         referenceCount: function() {
//             if (this.filter.length > 0) {
//                 return this.filteredPosts.length > 1 ? this.filteredPosts.length + ' Publikationen' : 'Eine Publikation';
//             } else {
//                 return 'Alle Publikationen';
//             }
//         },
//         tags: function() {
//             let results = Object.create(null);
//             this.posts.forEach(function(post) {
//                 post.categories.forEach(function(cat) {
//                     results[cat.term_id] = cat.name;
//                 });
//             });
//             return results;
//         },
//         yearsAvailable: function() {
//             let years = [];
//             this.posts.forEach(function(post) {
//                 let date = new Date(post.post_date).getFullYear();
//                 if (years.indexOf(date) === -1) {
//                     years.push(date);
//                 }
//             });
//             return years;
//         },
//         filteredPosts: function() {

//             let vm = this;
//             let filteredPosts = this.posts;

//             if (this.filter.length > 0) {
//                 filteredPosts = filteredPosts.filter(function(post) {
//                     let postCatIds = post.categories.map(function(cat) {
//                         return cat.term_id; 
//                     });
//                     for (let i = 0; i < vm.filter.length; i++) {
//                         let f = vm.filter[i];
//                         if (postCatIds.indexOf(f) !== -1) {
//                             return true;
//                         }
//                     }
//                     return false;
//                 });
//             }

//             if (this.year !== "") {
//                 filteredPosts = filteredPosts.filter(function(post) {
//                     let date = new Date(post.post_date).getFullYear();
//                     return date === vm.year;
//                 });
//             }

//             return filteredPosts;
//         }
//     },
//     methods: {
//         addFilter: function(tagId) {
//             let id = Number(tagId);
//             if (this.filter.includes(id)) {
//                 this.filter = this.filter.filter(function(el) {
//                     return el !== id;
//                 });
//             } 
//             else {
//                 this.filter.push(id);
//             }
//         }
//     },
//     mounted: function() {
//         var vm = this;
//         fetch('/wp-json/interessen-im-fluss/v1/publikationen')
//         .then(function(response) {
//             return response.json();
//         })
//         .then(function(data) {
//             console.log('Fetched data!');
//             console.log(data);
            
            
//             vm.posts = data;
//         });
//     }
// });
